export class ClientReferralLite implements IClientReferralLite {
  id!: number;
  clientReferralMemberIds!: number[];
  createdAt!: string;
  medicationManagement!: boolean;
  type!: string;

  constructor(json: IClientReferralLiteApiResponse) {
    this.id = json.id;
    this.clientReferralMemberIds = json.client_referral_member_ids;
    this.createdAt = json.created_at;
    this.medicationManagement = json.medication_management;
    this.type = json.type;
  }
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IClientReferralLiteApiResponse {
  id: number;
  client_referral_member_ids: number[];
  created_at: string;
  medication_management: boolean;
  type: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IClientReferralLite {
  id: number;
  clientReferralMemberIds: number[];
  createdAt: string;
  medicationManagement: boolean;
  type: string;
}
